import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Container } from './styled'
import {  FormItemColumn } from '../../helpers/formStyle'
import EventHeader from '../eventHeader/view'
import { joinEvent } from 'api'
import { Grid, Button } from '@mui/material'
import Box from '@mui/material/Box';
import { TextField, InputLabel } from '@mui/material';
import { useMutation } from 'react-query'
import { DO_LOGIN } from 'api/mutations'
import { useNavigate } from 'react-router'

const EventTicketLogin = ({ setLogin, event }) => {


  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })

  const [eventData,] = useState({
    event: event?.slug,
  })

  const [errors, setErrors] = useState({
    credentials: '',
  })

  const mutateLogin = useMutation(DO_LOGIN, {
    onSuccess: () => {
      joinEvent(eventData).then(r => {
        navigate(`/event-ticket/${r.ticket?.slug}`);
      }).catch(console.error)
    },
    onError: () => {
      setErrors({ ...errors, credentials: 'Sorry, looks like your password or email are not correct' })
      /*
      enqueueSnackbar(t('login.error'), {
        variant: 'error',
      })
      */
    },
  })

  const handleLogin = () => {
    mutateLogin.mutate(formData)
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  return (
    <Container>
      <EventHeader event={event} />
      <Box container spacing={2}>
        <Grid item xs={12}>
          <FormItemColumn>
            <InputLabel id="email">Your email</InputLabel>
            <TextField
              size='small'
              variant="outlined"
              required
              fullWidth
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </FormItemColumn>
        </Grid>
        <Grid item xs={12}>
          <FormItemColumn>
            <InputLabel id="password">Password</InputLabel>
            <TextField
              size='small'
              variant="outlined"
              fullWidth
              name="password"
              type="password"
              value={formData.password}
              onChange={handleInputChange}
            />            
          </FormItemColumn>          
        </Grid>        
      </Box>
      <Grid style={{marginBottom:'1em'}}>
      {errors.credentials && (<span style={{ color: 'red', paddingBottom: '1em', marginBottom: '1em' }}>{errors.credentials}</span>)}
      </Grid>      
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={3}>
          <Button
            variant="contained"
            color="button_color"
            onClick={handleLogin}
            fullWidth
          >Login
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="text"
            color="primary"
            onClick={() => setLogin(false)}
            fullWidth
          >I don&apos;t have an account, Signup.
          </Button>
        </Grid>
      </Grid>
    </Container>
  )
}

EventTicketLogin.propTypes = {
  setLogin: PropTypes.func,
  event: PropTypes.object,
}
EventTicketLogin.defaultProps = {
  setLogin: () => null,
  event: {},
}


export default EventTicketLogin
